exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GoogleMap1 .placeholder{width:100%;height:100%;color:#999;background-color:#f9f9f9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/GoogleMap1/GoogleMap1.s.scss
// module id = 946
// module chunks = 28